<template>
	<div class="s-gray-bg" style="min-height:100vh;padding-top: 1rem;">

		<div class="p-margin20 p-padding20   p-white-bg p-radius20 p-deepblack-text  s-box-shadow" style="width: auto;">
			<div class=" p-border2 p-color6-border  p-space-between p-box-center-y" style="padding:1rem 0rem 1rem 0rem;">
				<span class="p-font0-8 p-color2-text p-bold p-center">
					{{$t('measure.bloodPressure')  }}
				</span>
				<span>
					<span class="p-deepblack-text p-font1-4 p-bold">
						{{ dayData.sys+'/'+dayData.dia  }}
					</span>
					<span class="p-color2-text p-font0-8 p-bold"
						style="margin-left: 0.1rem;">mmHg</span>
				</span>
			</div>
			<div class="p-border2 p-color6-border " style="padding:1rem 0rem 1rem 0rem;">
				<span class="p-font0-8 p-color2-text p-bold">
					{{$t('measure.measureTime')  }}
				</span>

				
				<span class="p-font0-8  p-color2-text p-bold" style="float: right;">
					{{ time(dayData.sts).format($t('common.formatDateYMDHMS'))}}
				</span>
			</div>
			<div class="p-border2 p-color6-border " style="padding:1rem 0rem 1rem 0rem;">
				<span class="p-font0-8 p-color2-text p-bold">
					{{$t('measure.measureEndTime')  }}
				</span>
				
				<span class="p-font0-8  p-color2-text p-bold" style="float: right;">
					{{ time(dayData.ets).format($t('common.formatDateYMDHMS'))}}
				</span>
			</div>
			<div class="p-color6-border p-space-between p-box-center-y" style="padding:1rem 0rem 1rem 0rem;">
				<span class="p-font0-8 p-color2-text p-bold"> 
					{{ $t('measure.bloodPressureIndicators') }}
				</span>
				<span
					class="s-lightGray3  p-padding-left10 p-padding-right10 p-box-center  p-white-text p-bold"
					style="border-radius:1.25rem;  width:5rem; height:2rem; overflow:hidden;float:right;" 
					:class="[ ((checkAbnormal(dayData,'BP',this).level===0)? 'p-green3-bg' :(checkAbnormal(dayData,'BP',this).level===1?'p-orange1-bg':'p-red1-bg') )  ]">
						{{ checkAbnormalLanguageCustom(dayData,'BP',this).info  }}
				</span>
			</div>
		<!-- 	<div class="p-border2 p-color6-border " style="padding:1rem 0rem 1rem 0rem;">
				<span class="p-font0-8">
					同步时间
				</span>
				
				<span class="p-font0-8 p-color3" style="float: right;">
					{{ time(1622450860000).format('YYYY年MM月DD日 HH:mm')  }}
				</span>
			
			</div> -->
			<!-- <div class=" p-color6-border " style="padding:1rem 0rem 1rem 0rem;">
				<span class="p-font0-8">
					数据来源
				</span>
				
				<span class="p-font0-8 p-color3" style="float: right;">
					vita-TW1-D3007
				</span>
			
			</div> -->
		</div>

			
	       <div v-if="showDetail"  class="p-margin20  p-height-auto  p-font0-8 p-margin-top30" style="width:auto;">
		           <div class="p-padding-top30 p-padding-bottom10">
		               <div  class="p-line-height1 p-font0-8 p-deepblack-text p-bold" >血压指标</div>
		               <div  class="p-width100 p-height-auto p-line-height1-4 p-font0-8  p-center p-padding-top30 p-padding-bottom10">
		                   <ul  class="p-height-auto p-box-center-y">
		                       <li  class="p-float-left"  style="width:15%;">&nbsp;</li>
		                       <li  class="p-float-left p-green3-text p-bold "  style="width:20%;">正常血压</li>
		                       <li  class="p-float-left p-orange1-text p-bold"  style="width:20%;">正常高<br>值血压</li>
		                       <li  class="p-float-left p-red1-text p-bold"  style="width:20%;">一级<br>高血压</li>
		                       <li  class="p-float-left p-red1-text p-bold"  style="width:20%;">二级<br>高血压</li>
		                   </ul>
		                   <ul  class="p-height-auto p-padding-top20">
		                       <li  class="p-float-left p-color2-text p-bold"  style="width:15%;">收缩压</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">＜130</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">130~139</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">140~159</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">≥160</li>
		                   </ul>
		                   <ul  class="p-height-auto  p-padding-top20">
		                       <li  class="p-float-left p-color2-text p-bold"  style="width:15%;">舒张压</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">＜85</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">85~89</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">90~99</li>
		                       <li  class="p-float-left p-deepblack-text p-bold"  style="width:20%;">≥100</li>
		                   </ul>

		                   <div  class="p-line-height2 p-width-auto p-padding-top20 p-padding-left20 p-padding-right20 p-color2-text p-bold" style="text-align: left;"   >
		                       减少盐的摄入量；平衡膳食；避免有害使用酒精；经常运动；以及避免使用烟草。
		                   </div>
		               </div>

		           </div>
		       </div>


	</div>


</template>

<script>
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	import {
		checkAbnormal,
		checkAbnormalLanguage
	} from '@/utils/methods.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		data() {
			return {
				title: '',
				dayData:'',
				showDetail:true,
			}
		},
		methods: {
			checkAbnormal,
			checkAbnormalLanguage,
			checkAbnormalLanguageCustom(json, type){
				return checkAbnormalLanguage(json, type,this);
			},
		},
		created() {
			document.title =  this.$t('measure.bloodPressureDetail');

			this.dayData = this.$route.query.dayData;
			console.log("created this.dayData: ", this.dayData);
			
			console.log('changeLanguage'+this.$i18n.locale )
			if(this.$route.query.language!='zh'&&this.$route.query.language!='en'){
				this.showDetail=false;
			}
		},
		onLoad(query) {
			this.query = query;

			console.log("this.query: ", this.query);
			// uni.setNavigationBarTitle({
			// 	title: this.query.uname ? (decodeURI(this.query.uname) + '的' + this.typeJson[this.query
			// 		.dataType]) : this.typeJson[this.query.dataType]
			// });


			// if (this.query.toggleNum) this.toggleNum = Number(this.query.toggleNum);


			// 初始化操作、网页传参---------------------------------------------------------------------------------------------------------
			// http://192.168.31.35:8080/madara_page/#/pages/list?dataType=BP&pid=14440&uname=%E6%9D%A8%E7%A7%91
			// if (this.query.dataType === 'SN') {
			// 	this.lastTime = Number(this.query.ets) || '2100-01-01 00:00:01'; // 用于滚动加载
			// } else {
			this.lastTime = Number(this.query.ets) || -1; // 用于滚动加载
			// }

		},

	}
</script>

<style scoped>

</style>
